<template>
    <v-container fluid>
        <v-row justify="center">
            <v-col md="6">
                <courier-edit-form
                    title="Create new courier"
                    v-bind:isEditing="false"
                    v-bind:courierinfo="courierinfo"
                    v-on:submit="submit"
                    v-on:cancel="$router.go(-1)"
                />
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import courierApi from '@/api/courierApi';
import snackbar from '@/utils/snackbar';

export default {
    components: {
        'courier-edit-form': () => import('@/views/op/CourierEditForm.vue')
    },
    data() {
        return {
            courierinfo: {
                date_of_birth: null,
                address: null,
                emergency_contact: null,
                joining_date: null,
                leaving_date: null,
                user: {
                    name: null,
                    phone: null,
                    username: null,
                    password: null,
                    password_confirmation: null
                }
            }
        };
    },
    methods: {
        async submit() {
            const response = await courierApi.createCourier(this.courierinfo);
            this.$router.push({
                name: 'op-courierinfo-show',
                params: { courierinfo_id: response.data.courierinfo.id }
            });
            snackbar.show('Courier created', 'success');
        }
    }
};
</script>
